import styled from 'styled-components';

export const AdminHeaderWrapper = styled.div`
  position: sticky;
  top: 0;
  z-index: 101;
  background-color: ${({ theme }) =>
    theme.colors.grays.gray3 ?? theme.colors.backgroundDark};
  border-bottom: 1px solid
    ${({ theme }) => theme.colors.border.dark ?? theme.colors.border.light};
`;

export const AdminHeaderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.5rem 1rem;
  max-width: 1200px;
  margin: 0 auto;
`;

export const SpoofContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.375rem;
  width: 100%;
  max-width: 500px;
`;

export const SpoofLabel = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.colors.text.onDark ?? theme.colors.background};
  opacity: 0.9;
  font-size: 0.8rem;
  text-align: center;
  font-weight: 500;
`;

export const SpoofWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  align-items: center;
`;

export const SpoofNotice = styled.div`
  margin: 0.25rem 0;
  color: ${({ theme }) => theme.colors.text.onDark ?? theme.colors.background};
  opacity: 0.9;
  font-size: 0.8rem;
  text-align: center;
  background-color: ${({ theme }) =>
    `${theme.colors.text.onDark ?? theme.colors.background}26`};
  padding: 0.5rem 0.75rem;
  border-radius: ${({ theme }) => theme.borderRadius.xs};
  border: 1px solid
    ${({ theme }) => `${theme.colors.text.onDark ?? theme.colors.background}4d`};
  line-height: 1.3;

  strong {
    color: ${({ theme }) => theme.colors.text.onDark ?? theme.colors.background};
    font-weight: 600;
  }
`;
